import lscache from 'lscache';
import { http } from '../config/Constantes';

export const checkAuth = () => {
    
    if(lscache.get('access_token'))
    {
        return http.get('Acesso/esta-autenticado',{
            headers: { Authorization: lscache.get('access_token') }
        }).then((response) => {
            return response
        }).catch((error) => {
            if(error.response.status === 401){         
                lscache.flush();                   
                lscache.set("errorMessage","Senha expirada, acesse a opção 'esqueci minha senha'.")                
                window.location.replace('/login');
            }
        })
    }
}



// WEBPACK FOOTER //
// ./src/utils/security.js